import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../Interfaces/User';

import {EnvService} from '../env.service';
import {NavItem} from '../Interfaces/NavItem';
import {ImportStatusView} from '../Interfaces/ImportStatusView';
import {ClientRequest} from '../Interfaces/ClientRequest';
import {ListData} from '../Interfaces/ListData';
import {GateStatus} from '../Interfaces/GateStatus';
import {GateMove} from '../Interfaces/GateMove';
import {GateTransactionDetailsView} from '../Interfaces/GateTransactionDetailsView';
import {SSLView} from '../Interfaces/SSLView';
import {TruckingCompanyView} from '../Interfaces/TruckingCompanyView';
import {UtcsView} from '../Interfaces/UtcsView';
import {DetentionClaimsView} from '../Interfaces/DetentionClaimsView';
import {Customs} from '../Interfaces/Customs';
import {BookingsView} from '../Interfaces/BookingsView';
import {PeelOffPileParams} from '../Interfaces/PeelOffPileParams';
import {PeelOffParent} from '../Interfaces/PeelOffParent';
import {ContainerView} from '../Interfaces/ContainerView';
import {Sealink} from '../Interfaces/Sealink';
import {GuaranteesView} from '../Interfaces/GuaranteesView';
import {ContainerGuarantee} from '../Interfaces/ContainerGuarantee';
import {NotificationView} from '../Interfaces/NotificationView';
import {ApiCredentials} from '../Interfaces/ApiCredentials';
import {Report} from '../Interfaces/Report';
import {EmptyReceiveSchedule} from '../Interfaces/EmptyReceiveSchedule';
import {EmptyReceiveInfo} from '../Interfaces/EmptyReceiveInfo';
import {TruckerVisitErrors} from '../Interfaces/TruckerVisitErrors';
import {GateTransactionStages} from '../Interfaces/GateTransactionStages';
import {Visit} from '../Interfaces/Visit';
import {EmailReport} from '../Interfaces/EmailReport';
import {DemurrageLines} from '../Interfaces/DemurrageLines';

@Injectable({ providedIn: 'root' })
export class QueryService {

  constructor(
    private http: HttpClient,
    private env: EnvService) { }

 //do not subscribe in a service
  loginUser(user: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/loginUser',user);
  }

  getAllSslStorageCollections(user: ClientRequest): Observable<DemurrageLines[]> {
    return this.http.post<DemurrageLines[]>(this.env.apiUrl+'/userService/getAllSslStorageCollections',user);
  }


  saveNewAccount(user: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/saveNewAccount',user);
  }

  getAdminUser(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/getAdminUser',cr);
  }

  sendNewPassword(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/sendNewPassword',cr);
  }

  resetPassword(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/resetPassword',cr);
  }

  profileCheckPassword(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/profileCheckPassword',cr);
  }

  validateResetPassword(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/validateResetPassword',cr);
  }

  updatePassword(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/updatePassword',cr);
  }

  accountProfileUpdateUser(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/updateUser', cr);
  }


  getMenus(user: ClientRequest): Observable<NavItem[]> {
    return this.http.post<NavItem[]>(this.env.apiUrl+'/userService/getusermenus',user);
  }

  getVesselReceiveSchedule (user: ClientRequest): Observable<EmptyReceiveSchedule[]> {
    return this.http.post<EmptyReceiveSchedule[]>(this.env.apiUrl+'/driverService/getVesselReceiveSchedule ',user);
  }

  getEmptyReceiveInfo  (user: ClientRequest): Observable<EmptyReceiveInfo[]> {
    return this.http.post<EmptyReceiveInfo[]>(this.env.apiUrl+'/driverService/getEmptyReceiveInfo  ',user);
  }

  importInquiryQuery(user: ClientRequest): Observable<ImportStatusView[]> {
    return this.http.post<ImportStatusView[]>(this.env.apiUrl+'/importInquiryService/getContainers',user);
  }


  getLists(cr: ClientRequest): Observable<ListData[]> {
    return this.http.post<ListData[]>(this.env.apiUrl+'/listService/getLists',cr);
  }

  updateContainerList(cr: ClientRequest): Observable<ListData[]> {
    return this.http.post<ListData[]>(this.env.apiUrl+'/listService/updateList',cr);
  }

  //this fills count of 4 squares on main charts
  allGatesWithStatusCounts(cr: ClientRequest): Observable<GateStatus[]> {
    return this.http.post<GateStatus[]>(this.env.apiUrl+'/gateService/allGatesWithStatusCounts',cr);
  }
  //fills chart for DI,DE,RM,RE
  allGatesWithMoveCounts(cr: ClientRequest): Observable<GateMove[]> {
    return this.http.post<GateMove[]>(this.env.apiUrl+'/gateService/allGatesWithMoveCounts',cr);
  }


  //fills 4 squares for Empty Depot only
  emptyDepotGateStatusCounts(cr: ClientRequest): Observable<GateStatus[]> {
    return this.http.post<GateStatus[]>(this.env.apiUrl+'/gateService/emptyDepotGateStatusCounts',cr);
  }
  //fills chart for DI,DE,RM,RE for Empty Depot only
  emptyDepotGateMoveCounts(cr: ClientRequest): Observable<GateMove[]> {
    return this.http.post<GateMove[]>(this.env.apiUrl+'/gateService/emptyDepotGateMoveCounts',cr);
  }



  /************GATE ACTIVITY CALLS ******************/

  byVisit(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/byVisit',cr);
  }

  getAllCompleted(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/completed',cr);
  }
  getAllCancelled(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/cancelled',cr);
  }
  getAllInTrouble(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/inTrouble',cr);
  }
  getAllInProgress(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/inProgress',cr);
  }
  getAllRMs(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/getRM',cr);
  }
  getAllRIs(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/getRI',cr);
  }
  getAllREs(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/getRE',cr);
  }
  getAllDMs(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/getDM',cr);
  }
  getAllDIs(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/getDI',cr);
  }
  getAllDEs(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/getDE',cr);
  }
  byContainer(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/byContainer',cr);
  }

  byChassis(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/byChassis',cr);
  }

  byBooking(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/byBooking',cr);
  }

  inProgress(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/inProgress',cr);
  }

  inTrouble(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/gateService/inTrouble',cr);
  }

  /********** UTCS INQUIRY CALLS ********************/

  utcsBySslAndUser(cr: ClientRequest): Observable<UtcsView[]> {
    return this.http.post<UtcsView[]>(this.env.apiUrl+'/gateService/utcsBySslAndUser', cr);
  }

  utcsBySslAndTruckerCode(cr: ClientRequest): Observable<UtcsView[]> {
    return this.http.post<UtcsView[]>(this.env.apiUrl+'/gateService/utcsBySslAndTruckerCode', cr);
  }

  getAllSsls(cr: ClientRequest): Observable<SSLView[]> {
    return this.http.post<SSLView[]>(this.env.apiUrl+'/gateService/getAllSsls', cr);
  }

  getAllTruckingCompanies(cr: ClientRequest): Observable<TruckingCompanyView[]> {
    return this.http.post<TruckingCompanyView[]>(this.env.apiUrl+'/gateService/getAllTruckingCompanies', cr);
  }

  /************** DETENTION CLAIMS CALLS ************/
  claimInquiryByVisit(cr: ClientRequest): Observable<DetentionClaimsView[]> {
    return this.http.post<DetentionClaimsView[]>(this.env.apiUrl+'/claimsInquiryService/byVisit', cr);
  }

  claimInquiryByClaim(cr: ClientRequest): Observable<DetentionClaimsView[]> {
    return this.http.post<DetentionClaimsView[]>(this.env.apiUrl+'/claimsInquiryService/byClaim', cr);
  }

  claimInquiryAllClaims(cr: ClientRequest): Observable<DetentionClaimsView[]> {
    return this.http.post<DetentionClaimsView[]>(this.env.apiUrl+'/claimsInquiryService/allClaims', cr);
  }

  byFilter(cr: ClientRequest): Observable<DetentionClaimsView[]> {
    return this.http.post<DetentionClaimsView[]>(this.env.apiUrl+'/claimsInquiryService/byFilter', cr);
  }

  byFilterAndDates(cr: ClientRequest): Observable<DetentionClaimsView[]> {
    return this.http.post<DetentionClaimsView[]>(this.env.apiUrl+'/claimsInquiryService/byFilterAndDates', cr);
  }

  claimInquiryByDates(cr: ClientRequest): Observable<DetentionClaimsView[]> {
    return this.http.post<DetentionClaimsView[]>(this.env.apiUrl+'/claimsInquiryService/allByDates', cr);
  }


  claimEntryByVisit(cr: ClientRequest): Observable<DetentionClaimsView[]> {
    return this.http.post<DetentionClaimsView[]>(this.env.apiUrl+'/claimsEntryService/byVisit', cr);
  }


  claimEntryProcess(cr: ClientRequest): Observable<DetentionClaimsView[]> {
    return this.http.post<DetentionClaimsView[]>(this.env.apiUrl+'/claimsEntryService/process', cr);
  }


  customsGetContainers(cr: ClientRequest): Observable<Customs[]> {
    return this.http.post<Customs[]>(this.env.apiUrl+'/customsService/getContainers', cr);
  }

  customsAddHold(cr: ClientRequest): Observable<Customs[]> {
    return this.http.post<Customs[]>(this.env.apiUrl+'/customsService/addHold', cr);
  }

  customsReleaseHold(cr: ClientRequest): Observable<Customs[]> {
    return this.http.post<Customs[]>(this.env.apiUrl+'/customsService/releaseHold', cr);
  }


  getBookings(cr: ClientRequest): Observable<BookingsView[]> {
    return this.http.post<BookingsView[]>(this.env.apiUrl+'/bookingService/byBooking', cr);
  }


  peelOffPileInit(cr: ClientRequest): Observable<PeelOffPileParams> {
    return this.http.post<PeelOffPileParams>(this.env.apiUrl+'/peelOffPileService/init', cr);
  }

  peelOffPileGetContainers(cr: ClientRequest): Observable<PeelOffParent> {
    return this.http.post<PeelOffParent>(this.env.apiUrl+'/peelOffPileService/getContainers', cr);
  }

  peelOffPileProcess(cr: ClientRequest): Observable<PeelOffParent> {
    return this.http.post<PeelOffParent>(this.env.apiUrl+'/peelOffPileService/process', cr);
  }


  containerInquiryGetContainers(cr: ClientRequest): Observable<ContainerView[]> {
    return this.http.post<ContainerView[]>(this.env.apiUrl+'/containerService/getContainers', cr);
  }


  getAllSealinks(cr: ClientRequest): Observable<Sealink[]> {
    return this.http.post<Sealink[]>(this.env.apiUrl+'/gateService/allSealinks', cr);
  }

  getActiveSealinks(cr: ClientRequest): Observable<Sealink[]> {
    return this.http.post<Sealink[]>(this.env.apiUrl+'/gateService/activeSealinks', cr);
  }

  getTerminatedSealinks(cr: ClientRequest): Observable<Sealink[]> {
    return this.http.post<Sealink[]>(this.env.apiUrl+'/gateService/terminatedSealinks', cr);
  }

  getSealink(cr: ClientRequest): Observable<Sealink> {
    return this.http.post<Sealink>(this.env.apiUrl+'/gateService/getSealink', cr);
  }

  paymentInquiryGetContainers(cr: ClientRequest): Observable<ContainerView[]> {
    return this.http.post<ContainerView[]>(this.env.apiUrl+'/paymentInquiryService/getContainers', cr);
  }

  paymentGetContainers(cr: ClientRequest): Observable<ContainerView[]> {
    return this.http.post<ContainerView[]>(this.env.apiUrl+'/paymentService/getContainers', cr);
  }

  paymentCalculateDates(cr: ClientRequest): Observable<ContainerGuarantee[]> {
    return this.http.post<ContainerGuarantee[]>(this.env.apiUrl+'/paymentService/calculateDates', cr);
  }

  paymentProcess(cr: ClientRequest): Observable<ContainerGuarantee[]> {
    return this.http.post<ContainerGuarantee[]>(this.env.apiUrl+'/paymentService/process', cr);
  }

  paymentVoidGetContainers(cr: ClientRequest): Observable<ContainerView[]> {
    return this.http.post<ContainerView[]>(this.env.apiUrl+'/voidService/getContainers', cr);
  }

  paymentVoidProcess(cr: ClientRequest): Observable<GuaranteesView[]> {
    return this.http.post<GuaranteesView[]>(this.env.apiUrl+'/voidService/process', cr);
  }

  notificationGetPending(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/getPending', cr);
  }

  notificationGetSent(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/getSent', cr);
  }

  notificationSaveContainerReady(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/saveContainerReady', cr);
  }

  notificationSaveContainerReceived(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/saveContainerReceived', cr);
  }

  notificationSaveContainerDelivered(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/saveContainerDelivered', cr);
  }

  notificationSaveBooking(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/saveBooking', cr);
  }

  notificationSaveBookingReroute(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/saveBookingReroute', cr);
  }


  notificationDeleteContainerNotification(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/deleteContainerNotification', cr);
  }

  notificationDeleteBookingNotification(cr: ClientRequest): Observable<NotificationView[]> {
    return this.http.post<NotificationView[]>(this.env.apiUrl+'/notificationService/deleteBookingNotification', cr);
  }

  apiSubscriptionGetAPICreds(cr: ClientRequest): Observable<ApiCredentials> {
    return this.http.post<ApiCredentials>(this.env.apiUrl+'/tokenService/getApiCredentials', cr);
  }

  apiSubscriptionGenerateAPICreds(cr: ClientRequest): Observable<ApiCredentials> {
    return this.http.post<ApiCredentials>(this.env.apiUrl+'/tokenService/generateApiCredentails', cr);
  }

  getSubUser(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/getSubUser', cr);
  }



  saveSubUser(cr: ClientRequest): Observable<User> {
    return this.http.post<User>(this.env.apiUrl+'/userService/saveSubUser', cr);
  }

  getReports(cr: ClientRequest): Observable<Report[]> {
    return this.http.post<Report[]>(this.env.apiUrl+'/userService/getReports', cr);
  }

  getDirectReports(cr: ClientRequest): Observable<Report[]> {
    return this.http.post<Report[]>(this.env.apiUrl+'/userService/getDirectReports', cr);
  }


  getVisitByUsername(cr: ClientRequest): Observable<GateTransactionDetailsView[]> {
    return this.http.post<GateTransactionDetailsView[]>(this.env.apiUrl+'/driverService/getVisitByUsername', cr);
  }

  async getDriverVisitErrors(cr: ClientRequest): Promise<TruckerVisitErrors[]> {
    return await  this.http.post<TruckerVisitErrors[]>(this.env.apiUrl+'/driverService/getDriverVisitErrors', cr).toPromise();
  }


  async getGateStagesByVisit(cr: ClientRequest): Promise<Visit> {
    return await this.http.post<Visit>(this.env.apiUrl+'/driverService/getGateStagesByVisit', cr).toPromise();
  }

  getReportEmailsAddressByAccount(cr: ClientRequest): Observable<EmailReport[]> {
    return this.http.post<EmailReport[]>(this.env.apiUrl+'/driverService/getReportEmailsAddressByAccount', cr);
  }


  insertUpdateEmailReportAddress(cr: ClientRequest): Observable<EmailReport[]> {
    return this.http.post<EmailReport[]>(this.env.apiUrl+'/driverService/insertUpdateEmailReportAddress', cr);
  }

}

